var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipHelper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.5 19",
    style: {
      enableBackground: "new 0 0 18.5 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#707070;strokeWidth:0.5;}\n\t.st1{fill:#707070;stroke:#707070;strokeWidth:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    transform: "translate(-1227.75 -933.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_25",
    className: "st0",
    d: "M1237,934L1237,934c5,0,9,4,9,9v0.5c0,5-4,9-9,9l0,0c-5,0-9-4-9-9V943 C1228,938,1232,934,1237,934z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_26",
    className: "st1",
    d: "M1237,938.2L1237,938.2c0.3,0,0.5,0.2,0.5,0.5v9.2c0,0.3-0.2,0.5-0.5,0.5l0,0 c-0.3,0-0.5-0.2-0.5-0.5v-9.2C1236.5,938.4,1236.7,938.2,1237,938.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipHelper);
export default __webpack_public_path__ + "static/media/tooltip-helper.a3a50642a5d1e350a7902f966b9fa9c8.svg";
export { ForwardRef as ReactComponent };